<div fxLayout="row" fxFlex>
  @if (customViewDisplayLayout == customViewDisplayLayoutEnum.List) {
    <div class="sort-row" fxLayout="row" fxLayoutAlign="end center">
      <div fxFlexAlign="end" class="sort-by-label">Sort by:</div>
      <a
        [matMenuTriggerFor]="menu"
        [attr.title]="'Sort Talent'"
        class="sort-options"
        >{{ currentSortOption?.label }}
        <mat-icon>arrow_drop_down</mat-icon>
        <mat-menu #menu="matMenu" yPosition="below" [overlapTrigger]="false">
          @for (sort of sortOptions; track sort) {
            <button mat-menu-item (click)="changeSort(sort)">
              <span>{{ sort.label }}</span>
            </button>
          }
        </mat-menu>
      </a>
    </div>
  }
  @if (resultCount !== undefined) {
    <mat-paginator
      [length]="resultCount"
      [pageIndex]="pageIndex"
      [hidePageSize]="true"
      (page)="pageChanged($event)"
      aria-label="Change page"
    >
    </mat-paginator>
  }
</div>
